module.exports = __webpack_public_path__ + "static/media/grip-horizontal.a5f2f6c1.svg";